import { isPOBox } from '../../utils/address-validation';

const SEL_ADDRESS1 = 'input[name="address[address1]"]';
const SEL_ADDRESS2 = 'input[name="address[address2]"]';
const SEL_PO_BOX_ERROR_MSG = '[data-po-box-error-msg]';

const getPoBoxErrorMsg = () =>
  document.querySelector('[data-po-box-error]')?.dataset?.poBoxError ||
  'We cannot ship to P.O. Box addresses. Please enter a physical street address.';


const initAccountAddressForm = () => {
  // Validate any customer address form (edit or add) on submit
  document.addEventListener(
    'submit',
    (e) => {
      // In some cases the submit event target can be the submit button (not the form).
      // Use `closest('form')` so validation still runs.
      const form = e.target?.closest?.('form') || e.target;
      if (!form?.querySelector?.(SEL_ADDRESS1))
        return;
      const address1 =
        form.querySelector(SEL_ADDRESS1)?.value?.trim() || '';
      const address2 =
        form.querySelector(SEL_ADDRESS2)?.value?.trim() || '';
      if (isPOBox(address1, address2)) {
        e.preventDefault();
        const container = form.closest('[data-po-box-error]') || form;
        let errorEl = container.querySelector(SEL_PO_BOX_ERROR_MSG);
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'text-sm text-red-600 mt-1';
          errorEl.setAttribute('data-po-box-error-msg', '');
          errorEl.setAttribute('role', 'alert');
          const firstInputGroup = form.querySelector('.input-group');
          firstInputGroup?.after(errorEl);
        }
        errorEl.textContent =
          container.dataset?.poBoxError || getPoBoxErrorMsg();
        errorEl.classList.remove('hidden');
        return false;
      }
    },
    true
  );

  const addressEls = document.querySelectorAll('[data-account-address-item]');
  if (!addressEls.length) return;
  addressEls.forEach(address => {
    const editBtn = address.querySelector('[data-account-edit-address]');
    const editForm = address.querySelector('[data-address-edit-form]');
    const cancelBtn = editForm.querySelector('[data-edit-address-cancel]');
    const editFormOverlay = address.querySelector('[data-edit-address-overlay]');

    const toggleForms = () => {
      editForm.classList.toggle('hidden');
      editFormOverlay.classList.toggle('hidden');
      cancelBtn.addEventListener('click', toggleForms, { once: true });
    };
    editBtn.addEventListener('click', toggleForms);
  });
};

export default initAccountAddressForm;
